export const NUM_BUSINESSES_SHOWN = 3;
